(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bf-event-contact"] && !Shopify.designMode) return;
  try {
    
function setEventContactExpanded(section, expanded) {
  const button = section.querySelector('.bf-event-contact__toggle');
  const panel = section.querySelector('.bf-event-contact__panel');
  if (!button || !panel) return;
  button.setAttribute('aria-expanded', String(expanded));
  panel.hidden = !expanded;
  button.querySelector('span').textContent = expanded ? '−' : '+';
}
document.addEventListener('click', function(event) {
  const formatLink = event.target.closest('a[data-enquiry-format]');
  if (formatLink && formatLink.getAttribute('href') === '#event-enquiry') {
    const section = document.querySelector('.bf-event-contact');
    if (!section) return;
    const select = section.querySelector('select[name="contact[format]"]');
    const requestedFormat = formatLink.dataset.enquiryFormat;
    if (select && Array.from(select.options).some(function(option) { return option.value === requestedFormat; })) {
      select.value = requestedFormat;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    setEventContactExpanded(section, true);
    return;
  }
  const button = event.target.closest('.bf-event-contact__toggle');
  if (!button) return;
  setEventContactExpanded(button.closest('.bf-event-contact'), button.getAttribute('aria-expanded') !== 'true');
});
document.querySelectorAll('.bf-event-contact').forEach(function(section) {
  if (section.querySelector('.form-success, .errors')) setEventContactExpanded(section, true);
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bf-media-article"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = scope => scope.querySelectorAll('[data-media-article]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const body = root.querySelector('[data-media-body]');
    const gallery = root.querySelector('[data-media-gallery]');
    const images = [...body.querySelectorAll('img')];
    images.forEach((img, index) => {
      const figure = document.createElement('figure');
      figure.className = 'bfma__scan';
      figure.id = 'MediaScan-' + root.closest('[id]').id + '-' + index;
      img.loading = index === 0 ? 'eager' : 'lazy';
      img.decoding = 'async';
      if (!img.alt) img.alt = root.dataset.scanAlt.replace('[number]', String(index + 1));
      img.removeAttribute('style');
      figure.append(img);
      const caption = document.createElement('figcaption');
      const label = document.createElement('span');
      label.textContent = root.dataset.caption || root.dataset.source;
      const zoom = document.createElement('button');
      zoom.type = 'button';
      zoom.className = 'bfma__zoom';
      zoom.textContent = root.dataset.enlarge;
      zoom.setAttribute('aria-expanded', 'false');
      zoom.setAttribute('aria-controls', figure.id);
      zoom.addEventListener('click', () => {
        const expanded = figure.classList.toggle('bfma__scan--enlarged');
        zoom.setAttribute('aria-expanded', String(expanded));
        zoom.textContent = expanded ? root.dataset.reduce : root.dataset.enlarge;
      });
      const original = document.createElement('a');
      original.className = 'bfma__original';
      original.href = img.currentSrc || img.src;
      original.target = '_blank';
      original.rel = 'noopener';
      original.textContent = root.dataset.openOriginal;
      caption.append(label, zoom, original);
      figure.append(caption);
      gallery.append(figure);
    });
    body.querySelectorAll('p').forEach(p => {
      const text = p.textContent.replace(/\s+/g, ' ').trim();
      if (/^You can read the interview here\s*:/i.test(text) && p.querySelector('a')?.href === root.dataset.sourceUrl) p.remove();
      else if (/^Click picture to read the interview \(in German\)\.$/.test(text)) p.remove();
    });
    [...body.querySelectorAll('p,div,span,a')].reverse().forEach(node => {
      if (!node.textContent.replace(/\u00a0/g, ' ').trim() && !node.querySelector('img,iframe,video,audio,svg')) node.remove();
    });
    if (root.dataset.source === 'NZZ am Sonntag Magazin') {
      body.querySelectorAll('br').forEach(br => {
        const p = br.closest('p');
        if (!p) return;
        const range = document.createRange();
        range.setStartAfter(br);
        range.setEnd(p, p.childNodes.length);
        const next = document.createElement('p');
        next.append(range.extractContents());
        br.remove();
        p.after(next);
      });
    }
  });
  init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();

  } catch(e) { console.error(e); }
})();
})();
